module.exports = __webpack_public_path__ + "static/media/netflix.40882e5c.svg";